<template>
  <v-autocomplete
    :items="projectNames"
    v-model="valueModel"
    :label="labelValue"
    :clearable="clearable ? clearable : false"
    :readonly="readonly"
    :hide-details="hideDetails ? hideDetails : false"
    outlined
  ></v-autocomplete>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: [
    'value',
    'label',
    'clearable',
    'readonly',
    'hideDetails'
  ],
  data () {
    return {
      projectNames: []
    }
  },
  computed: {
    valueModel: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    },
    labelValue: {
      get () {
        return this.label ? this.label : 'Project Name'
      }
    }
  },
  methods: {
    ...mapActions('projects', [
      'getProjectOptions'
    ])
  },
  created () {
    this.getProjectOptions().then((projects) => {
      const names = Array.isArray(projects)
        ? projects
          .map(project => project.projectName)
          .filter(name => typeof name === 'string' && name.length)
        : []

      this.projectNames = [...new Set(names)].sort((a, b) => (a > b ? 1 : -1))
    })
  }
}
</script>
